import { render, staticRenderFns } from "./AboutGalaxy.vue?vue&type=template&id=448f6204&scoped=true"
import script from "./AboutGalaxy.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutGalaxy.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AboutGalaxy.vue?vue&type=style&index=0&id=448f6204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448f6204",
  null
  
)

export default component.exports